module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0748d_logo_200x200.a1b23ac0.png";